import React, { useState, useEffect, useCallback } from 'react';
import { API, C, authHeaders } from '../components/modportal/modApi';
import ModsTab from '../components/modportal/ModsTab';
import HowItWorks from '../components/modportal/HowItWorks';
import RollCallsTab from '../components/modportal/RollCallsTab';
import QATab from '../components/modportal/QATab';
import { MyProfileTab, TasksTab, AlertsTab } from '../components/modportal/MoreTabs';

export default function ModPortal({ user }) {
  const [me, setMe] = useState(null);
  const [tab, setTab] = useState('mods');

  const load = useCallback(function () {
    fetch(API + '/me/', { headers: authHeaders() })
      .then(function (r) { return r.json(); })
      .then(setMe)
      .catch(function () { setMe({ is_mod: false, error: 'Could not reach the portal.' }); });
  }, []);
  useEffect(function () { load(); }, [load]);

  if (!user) {
    return (
      <div style={{ padding: 40, textAlign: 'center', fontFamily: 'sans-serif' }}>
        <h2 style={{ fontSize: 18 }}>Sign in with Pi first</h2>
      </div>
    );
  }

  if (!me) {
    return <p style={{ textAlign: 'center', color: C.muted, padding: '3rem 0' }}>Loading...</p>;
  }

  if (!me.is_mod && !me.is_admin) {
    return (
      <div style={{ maxWidth: 560, margin: '0 auto', padding: '3rem 1.5rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
        <h2 style={{ fontSize: 19, margin: '10px 0 6px' }}>Pi Moderator Portal</h2>
        <p style={{ fontSize: 13, color: C.muted, lineHeight: 1.6 }}>
          This area is for the Pi moderation team. If you are a moderator,
          ask a Mega Mod to add your account - <b>@{user.username}</b>.
        </p>
      </div>
    );
  }

  const tabBtn = function (k, label, badge) {
    return (
      <button key={k} onClick={function () { setTab(k); }} style={{
        fontSize: 12.5, padding: '7px 13px', border: 'none', background: 'none',
        cursor: 'pointer', whiteSpace: 'nowrap',
        borderBottom: tab === k ? '2px solid ' + C.primary : '2px solid transparent',
        color: tab === k ? C.primary : C.muted, fontWeight: tab === k ? 700 : 400,
      }}>
        {label}
        {badge > 0 ? (
          <span style={{ marginLeft: 5, fontSize: 10, fontWeight: 700, color: '#fff', background: C.danger, borderRadius: 9, padding: '1px 6px' }}>{badge}</span>
        ) : null}
      </button>
    );
  };

  const c = me.counts || {};
  const pending = me.pending_rollcalls || [];

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '1.1rem 0.85rem 2rem', fontFamily: 'sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8, flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ fontSize: 20, margin: '0 0 2px' }}>Pi Moderator Portal</h1>
          <p style={{ fontSize: 11.5, color: C.muted, margin: 0 }}>
            {c.megas} mega - {c.mods} mods - {c.countries} countries
            {c.inactive > 0 ? ' - ' + c.inactive + ' inactive' : ''}
          </p>
        </div>
        <span style={{ fontSize: 11, color: C.muted }}>
          @{user.username}
          {me.is_admin ? ' - portal admin' : me.is_mega ? ' - mega mod' : ' - mod'}
        </span>
      </div>

      {pending.length > 0 && (
        <div style={{ background: '#FDF0DD', border: '1px solid ' + C.gold, borderRadius: 9, padding: '9px 12px', margin: '10px 0' }}>
          <p style={{ margin: 0, fontSize: 12.5, fontWeight: 700, color: C.gold }}>
            {pending.length} roll call{pending.length > 1 ? 's' : ''} waiting for you
          </p>
          {pending.map(function (r) {
            return <p key={r.id} style={{ margin: '3px 0 0', fontSize: 11.5, color: C.text }}>{r.title}</p>;
          })}
        </div>
      )}

      <div style={{ display: 'flex', gap: 2, borderBottom: '1px solid ' + C.border, margin: '10px 0 12px', overflowX: 'auto' }}>
        {tabBtn('mods', 'Team')}
        {tabBtn('rc', 'Roll calls', pending.length)}
        {tabBtn('qa', 'Q&A')}
        {tabBtn('tasks', 'Tasks', me.open_tasks)}
        {tabBtn('alerts', 'Notices')}
        {tabBtn('mine', 'My profile')}
        {tabBtn('how', 'How it works')}
      </div>

      {tab === 'mods' ? <ModsTab me={me} /> : null}
      {tab === 'how' ? <HowItWorks me={me} /> : null}
      {tab === 'rc' ? <RollCallsTab /> : null}
      {tab === 'qa' ? <QATab /> : null}
      {tab === 'tasks' ? <TasksTab me={me} /> : null}
      {tab === 'alerts' ? <AlertsTab me={me} /> : null}
      {tab === 'mine' ? <MyProfileTab me={me} onSaved={load} /> : null}
    </div>
  );
}
